const withinMonthRange = (monthsAhead = 1, referenceDate) => (value) => {
  let monthAhead;
  if (referenceDate) {
    monthAhead = new Date(referenceDate);
  } else {
    monthAhead = new Date();
  }
  monthAhead.setMonth(monthAhead.getMonth() + monthsAhead);
  return new Date(value).getTime() <= monthAhead.getTime();
};


export default withinMonthRange;
